<template>
  <div class="isLoading-container" ref="sentinel">
    <div v-if="loading" class="listLoading" role="status" aria-live="polite">{{ $t('common.listLoading') }}</div>
    <div v-if="finished" class="listNoMore">{{ $t('common.listNoMore') }}</div>
  </div>
</template>

<script>
export default {
  name: "isLoadingList",
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    finished: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      obServer: null,
    }
  },
  mounted() {
    this.obServer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !this.finished) {
        this.$emit('handler');
      }
    })
    this.obServer.observe(this.$refs.sentinel);
  },
  destroyed() {
    if (this.obServer) {
      this.obServer.disconnect();
    }
    this.obServer = null;
  }
};
</script>

<style scoped lang="scss">
.isLoading-container {
  min-height: 1px;
  .listLoading { font-size: .9rem; line-height: 3rem; color: var(--page-muted, #999); background: transparent; text-align: center;}
  .listNoMore { font-size: .9rem; line-height: 3rem; color: var(--page-muted, #999); background: transparent; text-align: center;}
}
</style>